<template>

  <sideBarView />



  <navbarView />



  <main class="main-sec" id="main">

    <div class="container">

      <div class="flex-bet-main mb-2">

        <div class="side-heading">

          <h6>{{ $t('buildingsView.title') }}</h6>

          <p class="font13 gray-col">{{ $t('buildingsView.subtitle') }}</p>

        </div>

        <router-link

          :to="{ name: 'addBuilding', params: { id: 0 } }"

          class="main-btn up"

          >{{ $t('buildingsView.addBuilding') }}</router-link

        >

      </div>

      <div v-if="!loader">

        <dataTable

          :tableData="filteredBuildings"

          :showLink="true"

          :HeadOfTable="HeadOfTable"

          linkDirection="buildingDetails"

        />

      </div>

      <div class="loader-main-axios" v-else>

        <div>{{ $t('buildingsView.loadingData') }}</div>

        <div class="spinner-small-white"></div>

      </div>

    </div>

  </main>

</template>



<script setup>

// imports

import sideBarView from "../components/dashboard/sideBarView.vue";

import navbarView from "../components/dashboard/navbarView.vue";

import dataTable from "../components/dashboard/dataTable.vue";


import { useI18n } from "vue-i18n";

import { ref, onMounted, computed } from "vue";

import { useStore } from 'vuex';

const store = useStore();

const { t } = useI18n();

// reactive state

const HeadOfTable = ref([

  {

    headText: t('buildingsView.serialNumber'),

    headKey: "id",

  },

  {

    headText: t('buildingsView.buildingCode'),

    headKey: "ref_code",

  },

  {

    headText: t('buildingsView.buildingName'),

    headKey: "name",

  },

  {

    headText: t('buildingsView.ownerName'),

    headKey: "owner.name",

  },

  {

    headText: t('buildingsView.phoneNumber'),

    headKey: "owner.phone",

  },

  {

    headText: t('buildingsView.additionDate'),

    headKey: "created_at",

  },

]);

// computed properties

const filteredBuildings = computed(() => store.getters.filteredBuildings);

const loader = computed(() => store.getters.isLoading);


// functions

const getBuildings = () => {

  store.dispatch('fetchBuildings');

};

// lifecycle hooks

onMounted(() => {

  getBuildings();

});

</script>
